import React from 'react';
import getEnvironDomain from 'utils/getEnvironDomain';

import FirmName from './components/FirmName';
import FirmDescription from './components/FirmDescription';
import Stars from './components/Stars';
import Facts from './components/Facts';
import Rating from './components/Rating';
import { FirmInfoStyles, Avatar, InfoContainer, InfoRow1, InfoRow2 } from './FirmInfoStyles';
import IconButton from './components/IconButton';
import Contact from './components/Contact';

function FirmInfo({ mt, account, advert, stars, contactsConfirmedCount }) {
  return (
    <FirmInfoStyles mt={mt}>
      <Avatar
        src={
          account.account_id
            ? `//api.${getEnvironDomain()}/v2/avatars/${account.account_id}/64`
            : ''
        }
      />
      <InfoContainer>
        <InfoRow1>
          <FirmName mw="none" account={account} />
          <FirmDescription account={account} />
        </InfoRow1>
        <InfoRow2 mt={6} stars={stars}>
          <Stars account={account} stars={stars} />
          {stars?.autopark_symbol_icon && (
            <IconButton
              src={stars.autopark_symbol_icon.image_link}
              text={stars.autopark_symbol_icon.body}
              id={`autopark_symbol_icon-${account?.account_id}`}
              href={`//${getEnvironDomain()}/firms/${account?.account_id}/autopark`}
            />
          )}
          <Facts ml={4} account={account} stars={stars} />
          <Rating ml={4} account={account} advert={advert} />
          {Boolean(contactsConfirmedCount) && <Contact count={contactsConfirmedCount} />}
        </InfoRow2>
      </InfoContainer>
    </FirmInfoStyles>
  );
}

export default FirmInfo;
